import { Section, CodeWrapper, Table, NcaLink } from 'nca-acquiring-theme';
import { applicationPropertiesSnippet, databaseConfigurationSnippet, inboundHttpsConnectionSnippet, inboundHttpsConnectionUsingPemSnippet, dsConfigLocationSnippet, securingCredentialsSnippet, loggingSnippet, outboundMtlsConnectionSnippet, outboundMtlsConnectionPemSnippet, deviceInfoDecryptionSnippet, serverSignedContentSnippet } from "../../../../src/snippets/applicationPropertiesSnippet";
import { dsConfigMinimalSnippet, dsConfigSchemaSnippet } from "../../../../src/snippets/ncaDsConfigSchemaSnippet";
import * as React from 'react';
export default {
  Section,
  CodeWrapper,
  Table,
  NcaLink,
  applicationPropertiesSnippet,
  databaseConfigurationSnippet,
  inboundHttpsConnectionSnippet,
  inboundHttpsConnectionUsingPemSnippet,
  dsConfigLocationSnippet,
  securingCredentialsSnippet,
  loggingSnippet,
  outboundMtlsConnectionSnippet,
  outboundMtlsConnectionPemSnippet,
  deviceInfoDecryptionSnippet,
  serverSignedContentSnippet,
  dsConfigMinimalSnippet,
  dsConfigSchemaSnippet,
  React
};